import React, { useState } from "react";
import MobileFilterCard from "../common/MobileFilterCard";
import ConfirmBox from "../Popup/ConfirmBox";
import AddonCard from "./AddonCard";
import "./AddonMobileList.css";
import { useTranslation } from "react-i18next";
import EmptyScreen from "../common/EmptyScreen";

function AddonMobileList({ addonGroups = [], onEdit, onDelete }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [deleteId, setDeleteId] = useState("");

  const filteredGroups = (addonGroups || []).filter((g) =>
    g.groupName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="addon-mobile-container">
      <MobileFilterCard
        label={t("Search add-ons")}
        hint={t("Find an add-on group by name.")}
        placeholder={t("Search add-on group...")}
        search={search}
        setSearch={setSearch}
        countText={`${filteredGroups.length} ${t("add-on groups")}${search.trim() ? ` ${t("found")}` : ""}`}
      />

      {filteredGroups.length === 0 ? (
        <EmptyScreen compact message="No add-on groups found." subText="Create an add-on group to offer extras and customisations." />
      ) : (
        <ul className="addon-card-list">
          {filteredGroups.map((group) => (
            <AddonCard
              key={group.addonGroupId}
              group={group}
              onEdit={onEdit}
              onDelete={(id) => setDeleteId(id)}
            />
          ))}
        </ul>
      )}

      <ConfirmBox
        variant="delete"
        isOpen={Boolean(deleteId)}
        title={"Are you sure you want to delete this Add-on Group?"}
        onConfirm={() => {
          if (deleteId) onDelete(deleteId);
        }}
        onCancel={() => setDeleteId("")}
      />
    </div>
  );
}

export default AddonMobileList;
